import { formatString } from "@@common";
import { IExpressionEvaluatorContext, IVariableScope, ObjectVariableScope, VariableScopeObserver } from "@@expressions";
import { useEffect, useState } from "react";

export default function useObservedText(textTemplate: string | undefined, context: IExpressionEvaluatorContext, loggerName: string): string | undefined {
  if (!textTemplate || !textTemplate.includes("{")) {
    return textTemplate;
  }

  // Note: These hooks are placed in this condition on purpoise to avoid unnecessary evaluation
  // The component definition WILL NOT change during the lifecycle of the component, so it's safe to call hooks conditionally based on its properties

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [text, setText] = useState("");

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    const observedPaths: string[] = [];
    setText(formatString(textTemplate, context.VariableScope, observedPaths));

    if (observedPaths.length === 0) {
      // No dynamic paths to observe, nothing to do
      return;
    }

    console.log(`[${loggerName}] Observed paths for text:`, observedPaths);

    const handleVariableScopeChanged: VariableScopeObserver = (target: IVariableScope, name: string | null, value: any, prevValue: any) => {
      console.log(`[${loggerName}] Variable scope changed for ${name}`, observedPaths);
      if (name !== null && !observedPaths.some((observedPath) => observedPath.startsWith(name))) {
        return;
      }
      console.log(`[${loggerName}] Variable scope changed for ${name}, updating text`);
      setText(formatString(textTemplate, context.VariableScope));
    };

    // Register observer to update text on variable scope changes
    const objectVariableScope = context.VariableScope as ObjectVariableScope;
    console.log(`[${loggerName}] Adding observer to variable scope.`);
    objectVariableScope.addObserver(handleVariableScopeChanged);

    return () => {
      console.log(`[${loggerName}] Removing observer from variable scope.`);
      objectVariableScope.removeObserver(handleVariableScopeChanged);
    };
  }, [context.VariableScope, textTemplate]);

  return text;
}
